import i18n from '@/utils/i18n';
import React from 'react';
import SearchIcon from '@assets/icons/search-magnifying-glass.svg';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';

interface PriceQuotesEmptyStateProps {
  onPress: () => void;
}

/**
 * Editor empty state shown when no account is selected. The CTA opens
 * the customer dropdown so the rep can pick an account and start a quote.
 */
export const PriceQuotesEmptyState: React.FC<PriceQuotesEmptyStateProps> = ({
  onPress,
}) => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      bottomElement={
        <Button
          accessibilityLabel={i18n.t('sales_portal.price_quotes.empty.cta')}
          onPress={onPress}
          size={ButtonSize.Small}
          style={styles.ctaButton}
          variant={ButtonVariant.Secondary}
        >
          {i18n.t('sales_portal.price_quotes.empty.cta')}
        </Button>
      }
      description={i18n.t('sales_portal.price_quotes.empty.description')}
      iconElement={
        <SearchIcon
          height={32}
          stroke={theme.sk.color.icon.primary}
          strokeWidth={1}
          width={32}
        />
      }
      title={i18n.t('sales_portal.price_quotes.empty.title')}
    />
  );
};

const useStyles = createStyles((theme) => ({
  ctaButton: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
